import React, { useState, useEffect } from "react";
import "./tacticsSelect.css";

export default function TacticSelect({ question, correctAnswers = [], onSubmit, onSkip }) {
  const terms = [
    "emotional language",
    "urgency appeal",
    "clickbait",
    "authority appeal",
    "selective framing",
    "binary thinking",
    "rage bait",
    "false equivalence",
    "exaggeration",
    "pseudo-intellectualism",
    "weaponised irony",
    "not manipulative"
  ];

  const [selected, setSelected] = useState([]);
  const maxTactics = question.tacticCount;
  useEffect(() => {
    setSelected([]);
  }, [question]);


  const toggle = (term) => {
    setSelected((prev) =>
      prev.includes(term) ? prev.filter(t => t !== term) : [...prev, term]
    );
  };

  const handleSubmit = () => {
    console.log("Selected tactics:", selected);
    console.log("Correct answers:", correctAnswers);
    console.log("Is correct:", selected.every(t => correctAnswers.includes(t)));
    if (onSubmit) {
      onSubmit(selected);
    }
  };

  const handleSkip = () => {
    console.log("Skipped question");
    if (onSkip) {
      onSkip();
    }
  };

  const rowsPerColumn = 6;

return (
  <div className="tacticSelectWrapper">
    <div className="checkboxGrid">
      {terms.map((term) => (
        <div
          key={term}
          className={`tacticOption ${selected.includes(term) ? "selected" : ""}`}
          onClick={() => toggle(term)}
        >
          {term}
        </div>
      ))}
    </div>
  
  <p className={`tacticCounter ${selected.length > maxTactics ? "overSelected" : "" }`}>
      TACTICS SELECTED: {selected.length}
  </p>

  <button className="submitButton" onClick={handleSubmit}>
        SUBMIT TACTICS
  </button>
  
  <button className="skipButton" onClick={handleSkip}>
        &gt;&gt; SKIP
  </button>
  </div>
  );
}
